<template>
    <div class="lbf-academy-page">
        <NavBar/>
        
        <h1>Questionnaires à réaliser</h1>

        <table>
            <tr>
                <th>Nom du questionnaire</th>
                <th>Actions</th>
            </tr>

            <tr v-for="evaluation in in_progress_list" :key="evaluation._id">
                <td>{{ evaluation.name }}</td>
                <td>
                    <span class="material-symbols-outlined" @click="openEvaluation(evaluation._id)">exit_to_app</span>
                </td>
            </tr>
        </table>

        <h1>Questionnaires terminés</h1>

        <table>
            <tr>
                <th>Nom du questionnaire</th>
                <th>Resultat</th>
            </tr>

            <tr v-for="evaluation in finished_list" :key="evaluation._id">
                <td>{{ evaluation.name }}</td>
                <td>
                    <span class="material-symbols-outlined" @click="openResult(evaluation._id)">insert_chart</span>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            in_progress_list: [],
            finished_list: [],
        }
    },
    methods: {
        openEvaluation(quizId) {
            this.$router.replace('/academy-evaluation/' + quizId);
        },
        openResult(quizId) {
            this.$router.replace('/academy-result/' + quizId);
        },
        async getInProgressQuizs() {
            const res = await axios.get(this.$store.getters.get_api_url + 'academy/quiz-in-progress/');
            this.in_progress_list = res.data;
        },
        async getInFinishedQuizs() {
            const res = await axios.get(this.$store.getters.get_api_url + 'academy/quiz-finished/');
            this.finished_list = res.data;
        },
    },
    mounted() {
        this.getInProgressQuizs();
        this.getInFinishedQuizs();
    }
}
</script>

<style scoped>
.lbf-academy-page {
    width: 800px;
    margin: 30px auto;
}

table {
    width: 100%;
}
table th,
table td {
    font-size: 14px;
    text-align: left;
    padding: 10px;
}
table th {
    background-color: #0A1C6B;
    color: white;
}
table td {
    background-color: white;
}
table td .material-symbols-outlined:hover {
    cursor: pointer;
    color: #FB984B;
}

table tr:first-child th:first-child {
    border-top-left-radius: 10px;
}
table tr:first-child th:last-child {
    border-top-right-radius: 10px;
}
table tr:last-child td:first-child {
    border-bottom-left-radius: 10px;
}
table tr:last-child td:last-child {
    border-bottom-right-radius: 10px;
}

table th:last-child,
table td:last-child {
    width: 60px;
    text-align: center;
}
</style>